'use strict';

function Notification(isNotificationEnabled, windowNotification) {
    var isEnabled = isNotificationEnabled || 'Notification' in window;
    var NotificationService = windowNotification || window.Notification;
    var GRANTED = 'granted';

    return {
        ERROR: 'Notification are not enabled in this browser',
        isEnabled: function() {
            return isEnabled;
        },
        getPermission: function() {
            return isEnabled ? NotificationService.permission : undefined;
        },
        requestPermission: function() {
            var dfr = $.Deferred();
            if (!isEnabled) {
                dfr.reject(this.ERROR);
            } else if (NotificationService.permission !== GRANTED) {
                var cb = Odigeo._.once(function(permission) {
                    dfr.resolve(permission);
                });
                var prom = NotificationService.requestPermission(cb);
                if (Odigeo._.isFunction(prom.then)) {
                    prom.then(cb);
                }
            } else {
                dfr.resolve(NotificationService.permission);
            }

            return dfr.promise();
        },
        send: function(title, options, onClickCb, onCloseCb) {
            var dfr = $.Deferred();
            var notification;
            var defaultOptions = {
                icon: Odigeo.Utils.getImageFromCDN('onefront/bluestone/' + Odigeo.SessionScope.brand + '/OpenGraph.png'),
            };
            if (isEnabled && NotificationService.permission === GRANTED) {
                Odigeo._.extend(defaultOptions, options);
                notification = new NotificationService(title, defaultOptions);
                if (Odigeo._.isFunction(onClickCb)) {
                    notification.onclick = onClickCb;
                }
                if (Odigeo._.isFunction(onCloseCb)) {
                    notification.onclose = onCloseCb;
                }
                dfr.resolve(notification);
            } else {
                dfr.reject(this.ERROR);
            }
            return dfr.promise();
        },
    };
}

var instance;
module.exports.Notification = Notification;
module.exports.notificationService = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new Notification();
    }
    return instance;
};
